import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './languages';
import en from './locales/en.json';
import lt from './locales/lt.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: { escapeValue: false },
    detection: {
      // Navigator language is deliberately absent: English is the default for
      // everyone until the visitor picks a language themselves.
      order: ['localStorage'],
      lookupLocalStorage: 'stututu_locale',
      caches: ['localStorage'],
    },
    resources: {
      en: { translation: en },
      lt: { translation: lt },
    },
  });

export default i18n;
